// eslint-disable-next-line @typescript-eslint/no-explicit-any
const extract = (object, path) => {
    return path.reduce((o, k) => (o || {})[k], object);
};

export { extract };
//# sourceMappingURL=extract.js.map
